import angular from 'angular';

import component from './cta-button-configure.component';

const CtaButtonConfigure = angular
    .module('control-room.commons.form.components.cta-button-configure', [])
    .component('crCtaButtonConfigure', component);

export default CtaButtonConfigure;
